export enum EnvironmentType {
	local = 1,
	develop = 2,
	staging = 3,
	production = 4,
	develop_frontend = 5
}
